import { Box, Grid, Typography, useTheme } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import { Applicant, ApplicationProps, DataMaster, DataMasters, dataTypeMasters } from '../../redux-store/types/api-types';
import {
  addressTypesMasters,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  AmlCheck,
  USER_ROLES,
} from '../../utils/constant';
import {
  applicationComparison,
  applyRoleBasedStatus,
  getApplicantName,
  isOnboardingTypeMinor,
  removeSingleQuote,
  saveForLater,
  sendRoleBasedStatus,
} from '../../utils/utilityFunctions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useRouteMatch } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { FATCAValidationSchema } from '../../utils/schema';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
// import { getNationalityList } from '../../redux-store/actions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import React from 'react';
import { getDataMasters } from '../../redux-store/actions/onBoarding';
import { showError } from '../../redux-store/actions/auth';

export type Values = {
  applicants: Partial<Applicant>[];
  saveType: string;
  countryDropdown: string[];
};

const initialValues: Values = {
  applicants: [
    {
      typeOfAddressProvidedAtKRA: '',
      amlCheck: false,
      taxResidentOfAnyCountryOtherThanIndia: false,
      placeOfBirth: '',
      countryOfBirth: '',
      countryOfNationality: '',
      taxCountryName: '',
      taxID: '',
      idType: '',
      nameOfEntity: '',
      dateOfIncorporation: '',
      cityOfIncorporation: '',
      countryOfIncorporation: '',
      entityExcemptionCode: '',
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

const FatcaDetails = ({
  applicantName,
  index,
  values,
  nationalitiesMdmsResponse,
  dataMasterLoading,
  dataMasters,
  onboardingSubType = '',
  onboardingType = ''
}: {
  applicantName: string;
  index: number;
  values: Partial<Applicant>;
  nationalitiesMdmsResponse: dataTypeMasters[];
  dataMasterLoading: boolean;
  dataMasters: DataMaster;
  onboardingSubType: string;
  onboardingType: string;
}): JSX.Element => {
  const { path: currentPath } = useRouteMatch();
  const theme = useTheme();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")
  const isFieldDisabled = isDiyInvestorOnboarding ? false : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);
  // const isRMFieldDisabled = ![USER_ROLES.INVESTOR].includes(role);
  const isRMFieldDisabled = false;

  const {
    FATCA_ADDRESS_TYPE = [],
    FATCA_ID_TYPE = []
  } = dataMasters ?? {};
  return (
    <>
      {/* <SubHeading>FATCA Details of {applicantName} Applicant</SubHeading> */}
      <Grid item xs={12}>
        <SubHeading sx={{ marginTop: '26px' }}>
          <Typography
            sx={{
              color: `${theme.palette.primary[900]}`,
              fontSize: "16px",
              fontFamily: `${theme.typography.fontFamily}`,
              letterSpacing: '0.2px',

            }}>

              {/* FATCA Details of {applicantName} Applicant */}
            {isOnboardingTypeMinor(onboardingType)? 'FATCA Details of Guardian': `FATCA Details of ${applicantName ?? ''} Applicant`}

          </Typography>
        </SubHeading>
      </Grid>

      {/* <Grid container> */}

      {/* <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.amlCheck`}
          label="AML Check *"
          items={Object.keys(AmlCheck)?.map((aml) => ({
            key: AmlCheck[aml],
            value: aml,
          }))}
          disabled={true}
        />
      </Grid> */}
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.typeOfAddressProvidedAtKRA`}
          label={`Type of Address Provided At KRA ${isRMFieldDisabled ? '' : '*'}`}
          // items={addressTypesMasters.map((address) => ({ key: address, value: address }))}
          items={FATCA_ADDRESS_TYPE?.map((val: dataTypeMasters) => ({ key: val?.description, value: val?.description }))}
          disabled={dataMasterLoading}
          loading={dataMasterLoading}
        />
      </Grid>
      <Grid item xs={12} lg={6} />
      {/* </Grid> */}

      <Grid item xs={12} lg={6}>
        {/* <Grid item xs={12} lg={6} sx={{ pt: '25px !important' }}> */}
        <UseRadioGroup
          formLabel={`Tax Resident of any country other than India ${isRMFieldDisabled ? '' : '*'}`}
          name={`applicants.${index}.taxResidentOfAnyCountryOtherThanIndia`}
          items={[
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ]}
          value={values.taxResidentOfAnyCountryOtherThanIndia?.toString()}
          disabled={isFieldDisabled || `${onboardingSubType || ''}`.toLowerCase() !== 'individual'}
        />
        {/* </Grid> */}
      </Grid>
      <Grid item lg={6} sx={{ display: { xs: 'none', lg: 'block' } }} />
      {/* {applicant?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && ( */}
      <>
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.placeOfBirth`}
            label={`Place of Birth ${isRMFieldDisabled ? '' : '*'}`}
            placeholder="Enter Place of Birth"
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            placeholder="Enter Country of Birth"
            disabled={isFieldDisabled}
          /> */}
          {/* <SearchableSelect
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          /> */}
          {/* <MFSelectField
            name={`applicants.${index}.countryOfBirth`}
            label={'Country Of Birth *'}
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            isCapitalize
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfBirth`}
            label={`Country Of Birth ${isRMFieldDisabled ? '' : '*'}`}
            items={nationalitiesMdmsResponse.map((nationality: any) => ({
              key: nationality?.description,
              value: nationality?.description,
            }))}
            disabled={isFieldDisabled || dataMasterLoading}
            searchFieldPlaceholder={'Search Country'}
            loading={dataMasterLoading}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            placeholder="Enter Country of Nationality"
            disabled={isFieldDisabled}
          /> */}
          {/* <SearchableSelect
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          /> */}
          {/* <MFSelectField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            isCapitalize
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfNationality`}
            label={`Country of Nationality ${isRMFieldDisabled ? '' : '*'}`}
            items={nationalitiesMdmsResponse.map((nationality: any) => ({
              key: nationality?.description,
              value: nationality?.description,
            }))}
            disabled={isFieldDisabled || dataMasterLoading}
            searchFieldPlaceholder={'Search Country'}
            loading={dataMasterLoading}
          />
        </Grid>
        {values?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && (
          <>
            <Grid item xs={12} sm={6}>
              {/* <MFTextField
                name={`applicants.${index}.taxCountryName`}
                label={`Tax country Name ${isRMFieldDisabled ? '' : '*'}`}
                placeholder="Enter Tax country Name"
                disabled={isFieldDisabled}
              /> */}
              <SearchableSelect
                name={`applicants.${index}.taxCountryName`}
                label={`Tax country Name ${isRMFieldDisabled ? '' : '*'}`}
                items={nationalitiesMdmsResponse.map((nationality: any) => ({
                  key: nationality?.description,
                  value: nationality?.description,
                }))}
                disabled={isFieldDisabled}
                searchFieldPlaceholder={'Search Tax Country'}
                loading={dataMasterLoading}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`applicants.${index}.taxID`}
                label={`Tax ID ${isRMFieldDisabled ? '' : '*'}`}
                placeholder="Enter Tax ID"
                disabled={isFieldDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* <MFTextField
                name={`applicants.${index}.idType`}
                label={`ID Type ${isRMFieldDisabled ? '' : '*'}`}
                placeholder="Enter ID Type"
                disabled={isFieldDisabled}
              /> */}
              <MFSelectField
                name={`applicants.${index}.idType`}
                label={`ID Type ${isRMFieldDisabled ? '' : '*'}`}
                items={FATCA_ID_TYPE?.map((idType: dataTypeMasters) => ({
                  key: idType.description,
                  value: idType.description,
                }))}
                disabled={isFieldDisabled}
                isCapitalize
                />
            </Grid>
          </>
        )}
        {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.nameOfEntity`}
              label="Name of Entity"
              placeholder="Enter Name of Entity"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Date of Incorporation"
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              maxDate={minDateForContributor()}
              name={`applicants.${index}.dateOfIncorporation`}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              value={applicant.dateOfBirth || minDateForContributor().toString()}
              onChange={(newValue) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant, ind) => {
                    if (index === ind) {
                      return {
                        ...applicant,
                        dateOfIncorporation: newValue?.toString(),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
              textFieldStyles={{
                'label + &': {
                  mt: 4,
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #DDEAF3',
                },
                '& .MuiOutlinedInput-root': {
                  position: 'relative',
                  backgroundColor: 'common.white',
                  border: '1px solid #DDEAF3',
                  fontSize: 16,
                  '&:hover': {
                    borderColor: 'primary.main',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: 0,
                  },
                  '.MuiInputBase-input': {
                    p: '10px 12px',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.cityOfIncorporation`}
              label="City of Incorporation"
              placeholder="Enter City of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.countryOfIncorporation`}
              label="Country of Incorporation"
              placeholder="Enter Country of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.entityExcemptionCode`}
              label="Entity Exemption Code"
              placeholder="Enter Entity Exemption Code"
            />
          </Grid> */}
      </>
      {/* )} */}
    </>
  );
};

export default function Fatca(): JSX.Element {
  const { path: currentPath } = useRouteMatch();

  const [fatcaDetails, setFatcaDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  // const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [dataMasters, setDataMasters] = useState<DataMaster>({} as DataMaster);
  const [dataMasterLoading, setDataMasterLoading] = useState<boolean>(false);

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")
  // const isRMFieldDisabled = isDiyInvestorOnboarding ? false : ![USER_ROLES.INVESTOR].includes(role);
  const isRMFieldDisabled = false;
  const [isShowErrPopup, setShowErrPopup] = useState<boolean>(false);


  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const nationalitiesMdmsMasters = (await dispatch(
  //         getNationalityList()
  //       )) as unknown as nationaliyType;
  //       setMdmsCountriesList(nationalitiesMdmsMasters.countries);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
  //       setDataMasters(res?.data ?? {});
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);


  useEffect(() => {
    const { applicants = [] } = application || {};
    (async function () {
      try {
        // const nationalitiesMdmsMasters = (await dispatch(
        //   getNationalityList()
        // )) as unknown as nationaliyType;
        // setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setDataMasterLoading(true);
        const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
        if (res?.data) {
          setDataMasterLoading(false);
          setDataMasters(res?.data ?? {});
        }

        setFatcaDetails({
          ...fatcaDetails,
          applicants: applicants?.map((applicant) => ({
            typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
            taxResidentOfAnyCountryOtherThanIndia: `${applicant.onboardingSubType || ''}`.toLowerCase() !== 'individual' ? true :
              applicant.taxResidentOfAnyCountryOtherThanIndia || false,
            placeOfBirth: applicant.placeOfBirth || '',
            countryOfBirth: applicant.countryOfBirth
              ? applicant.countryOfBirth : 'India',
            countryOfNationality: applicant.countryOfNationality
              ? applicant.countryOfNationality : 'India',
            taxCountryName: applicant.taxCountryName || '',
            taxID: applicant.taxID || '',
            idType: applicant.idType || '',
            amlCheck: applicant.amlCheck || false,
            nameOfEntity: applicant.nameOfEntity || '',
            dateOfIncorporation: applicant.dateOfIncorporation || '',
            cityOfIncorporation: applicant.cityOfIncorporation || '',
            countryOfIncorporation: applicant.countryOfIncorporation || '',
            entityExcemptionCode: applicant.entityExcemptionCode || '',
          })),
          countryDropdown: res?.data?.COUNTRY?.map((list: any) => list?.description) || [],
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants: existingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { applicants, saveType } = values;
      const updatedPayload = existingApplicants.map((applicant, index: number) => {
        const {
          taxResidentOfAnyCountryOtherThanIndia = false,
          // dateOfBirth = '',
          dateOfIncorporation = '',
          ...rest
        } = applicants[index];
        return {
          ...applicant,
          taxResidentOfAnyCountryOtherThanIndia:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' ? false : true,
          // dateOfBirth: dateOfBirth ? dateOfBirth : null,
          dateOfIncorporation: dateOfIncorporation ? dateOfIncorporation : null,
          ...rest,
          placeOfBirth: removeSingleQuote(rest.placeOfBirth),
          taxCountryName:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.taxCountryName),
          taxID:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.taxID),
          idType:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(rest.idType),
        };
      });
      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedPayload,
        currentStep: !!currentStep && currentStep > 6 ? currentStep : Number(currentStep) + 1,
      });
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        const response = await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedPayload,
              // status:
              //   !hasPOA &&
              //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
              //     status !== 'draft' &&
              //     applyRoleBasedStatus(role)
              //     ? 'sent_to_amc_approver'
              //     : status,
              status: sendRoleBasedStatus(role, status as string),
              currentStep: 7,
              //!!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        if (!response) {
          setLoading(false);
          return;
        }
        !isSaveLater
          ? history.push('bank-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('bank-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const {
    COUNTRY = [],
  } = dataMasters || {};

  return (
    <Formik
      initialValues={fatcaDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, FATCAValidationSchema(isRMFieldDisabled), true, values);
        } catch (e) {
          if (isShowErrPopup) {
            setShowErrPopup(false);
            dispatch(showError(`Please fill all required fields`));
          }
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          columnSpacing={3}
          rowSpacing={1}

          // sx={{
          //   width: '100%',
          //   ml: 0,
          //   '.MuiGrid-item': { px: { xs: 0, sm: '0px' } },
          // }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>

          <Grid item xs={12}>
            <Notes
              displayContent={'FATCA Information is mandatory to disclose any Foreign Citizenship'}
            />
          </Grid>


          {values.applicants.map((applicant, index) => (
            <React.Fragment key={index}>
              {/* <Grid item xs={12} /> */}
              <FatcaDetails
                applicantName={getApplicantName(index + 1)}
                index={index}
                key={index}
                values={applicant}
                nationalitiesMdmsResponse={COUNTRY}
                dataMasterLoading={dataMasterLoading}
                dataMasters={dataMasters}
                onboardingSubType={application?.applicants?.[index]?.onboardingSubType ?? ''}
                onboardingType={application?.applicants?.[index]?.onboardingType ?? ''}
              />
            </React.Fragment>
          ))}
          <Grid item xs={12} sx={{ columnGap: 2 }} />

          <ProceedSaveLater
            saveLater={() => {
              setShowErrPopup(true);
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setShowErrPopup(true);
              setValues({
                ...values,
                saveType: 'save and proceed',

              });

            }}
            loader={loading}
            clickedButton={values.saveType}
            saveButtonText='Continue'
            showEndIcon={false}
          />

        </Grid>
      )}
    </Formik>
  );
}
